export enum TrailSystemRelations {
  trails = 'trails',
  weatherGroups = 'weatherGroups',
  trailStewards = 'trailStewards',
  parkingLots = 'parkingLots',
}
